import _ from 'lodash'

export default class Report {
  id = null

  constructor (data) {
    _.forEach(data, (value, field) => {
      if (this.hasOwnProperty(field)) {
        this[field] = value
      }
    })
  }
}
